module.exports = "<kendo-grid-column-chooser #component></kendo-grid-column-chooser>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-datatable/src/components/column-chooser/column-chooser.component.html
// module id = ./libs/chassis-datatable/src/components/column-chooser/column-chooser.component.html
// module chunks = main